exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pointer[data-v-5b9bb543] {\r\n  cursor: pointer;\n}\n.carousel-image-text[data-v-5b9bb543] {\r\n  bottom: 10px;\r\n  left: 10px;\r\n  color: rgba(255, 255, 255, 0.7);\n}\r\n", ""]);

// exports
